// extracted by mini-css-extract-plugin
export var core = "Header-module--core--63zbh";
export var customHeight = "Header-module--customHeight--sJNJL";
export var insta = "Header-module--insta--BHy7k";
export var navVisibleMobile = "Header-module--nav-visible-mobile--vkRoH";
export var openMenuMobile = "Header-module--open-menu-mobile--Sm5yg";
export var slideDown = "Header-module--slideDown--+Lk8n";
export var visible = "Header-module--visible--WIj76";